import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Row } from 'react-bootstrap';

@observer
export default class Error404View extends React.Component {
    render() {
        return (
            <main className="error error-404">
                <section className="error-body">
                    <header>
                        <div className="badge">
                            <h5>error</h5>
                            <h6>404</h6>
                        </div>
                        <h1 className="page-title">
                            Looks like we took a wrong turn.
                        </h1>
                    </header>

                    <h2>The page you were seeking is no longer available.</h2>
                    <p>
                        We apologize for the inconvenience and invite you to{' '}
                        <Link to="/">review market reports.</Link>
                    </p>
                </section>
            </main>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/errors/error404/Error404View.jsx